<template>
  <div class="home-view">
    <div class="home-view__container">
      <transition
        name="custom-classes-transition"
        enter-active-class="animated fadeInRight"
        leave-active-class="animated fadeOutLeft"
      >
        <TheSignature />
      </transition>

      <TheCarousel
        :images="images"
        :delay="7000"
      />
    </div>

    <div class="home-view__container">
      <transition
        name="custom-classes-transition"
        enter-active-class="animated fadeInRight"
        leave-active-class="animated fadeOutLeft"
      >
        <TheBanner
          :content="banner"
          v-show="showPress"
        />
      </transition>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import TheCarousel from '@blocks/TheCarousel'
import TheBanner from '@blocks/TheBanner'
import TheSignature from '@blocks/TheSignature'

import View from '@mixins/View'
import { wait } from '@modules/time'
export default {
  name: 'HomeView',
  mixins: [ View ],
  components: {
    TheCarousel,
    TheBanner,
    TheSignature
  },
  data () {
    return {
      showPress: false,
      transition: ''
    }
  },
  computed: {
    ...mapGetters({
      device: 'breakpoints/getDevice',
      images: 'page/getImages',
      banner: 'page/getBanner'
    })
  },
  created () {
    this.fetchGetPage({ name: 'home' })
  },
  mounted () {
    wait(1000, () => {
      this.showPress = true
    })
  },
  methods: {
    ...mapActions({
      fetchGetPage: 'page/fetchGetPage'
    })
  }
}
</script>

<style lang="scss">
.home-view{
  @include media("small"){
    min-height: 100vh;
  }
  @include media("medium-large"){
    height: 100vh;
  }
  width: 100%;
  background-color: black;

  &__container{
    position: relative;
  }

  .signature{
    @include absolute-center;
    z-index: 10;
  }

  .carousel{
    position: relative;
    z-index: 0;
    height: 100vh;

    &::after{
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      background-color: rgba(black, 0.4);
      width: 100%;
      height: 100%;
      z-index: 1;
      pointer-events: none;
    }

    .swiper-container{
      height: 100%;
    }
  }

  .banner{
    @include media("medium-large"){
      @include add-box-shadow-center;
      position: fixed;
      bottom: 0;
      right: layout("spacing");
      z-index: 1;
    }
  }
}
</style>
